export default "__VITE_ASSET__a1691d92__"